module.exports = __webpack_public_path__ + "img/ic_plane.0f791a84.svg";